<template>
  <div class="btn-wrapper d-flex">
    <div @click.capture="goToPayment" class="go-back w-40">
      <span class="d-flex cursor-pointer">
        <img src="@/assets/img/arrow_left.svg" alt="back" />
        {{ title }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "BackCustomBtn",
  props: {
    title: String,
    extraData: String,
  },
  methods: {
    goToPayment() {
      this.$emit("click", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  span {
    justify-content: center;
    img {
      width: 10px;
      margin-right: 10px;
    }
  }
  &:hover {
    color: #222641;
    text-decoration: none;
  }
}
.btn-wrapper {
  text-align: center;
}
</style>
